import { render, staticRenderFns } from "./ServerGroups.vue?vue&type=template&id=17a936be&scoped=true"
import script from "./ServerGroups.vue?vue&type=script&lang=js"
export * from "./ServerGroups.vue?vue&type=script&lang=js"
import style0 from "./ServerGroups.vue?vue&type=style&index=0&id=17a936be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a936be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCardText,VCol,VRow,VSelect})
